"use client";

import { axiosAdmin } from "@/lib/axios";
import { useGenericMutation } from "@/components/query/useGenericMutation";

export const useAddToSubscibers = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.post("/user/subscriber", data),
    onSuccessMessage: "Confirmation email sent. Please check your inbox.",
    queryKeyToInvalidate: "getsubscribers",
  });
};